module.exports = __webpack_public_path__ + "static/media/mouse-pointer.6aee8fd7.svg";